import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { isAdminUser } from "../../../../utils/ModuleAccessUtils";

/**
 * O pote é o valor das assinaturas vezes o percentual configurado. Sem percentual não há o que
 * ratear, e os cards zerados ao lado das pontuações pareciam erro de cálculo.
 */
export const isPotPercentageMissing = (percentage) => !(Number(percentage) > 0);

/**
 * Aviso que substitui os valores do pote enquanto o percentual não foi configurado.
 * A aba Gamificação das configurações é só de administradores, então os demais perfis
 * recebem a orientação de procurar o gestor em vez de um link que não abriria nada.
 */
const PotPercentageNotice = () => {
    const { t } = useTranslation();

    return (
        <Alert variant="warning">
            <p className="mb-2">{t('gamification.pot_percentage_missing')}</p>
            {isAdminUser() ? (
                // Com aparência de botão porque o alert-link fica ilegível no tema escuro.
                <Link to="/setting/gamification" className="btn btn-primary btn-sm">
                    {t('gamification.pot_percentage_configure')}
                </Link>
            ) : (
                <p className="mb-0">{t('gamification.pot_percentage_contact_manager')}</p>
            )}
        </Alert>
    );
};

export default PotPercentageNotice;
